import React from 'react';
import { StockPage } from './pages/StockPage';
export function App() {
  return <StockPage data-id="element-0" />;
}